import type { AppProps } from 'next/app'
import { AuthProvider } from '@/contexts/AuthContext'
import '@/styles/globals.css' // se existir
import { useState, useEffect } from 'react'

export default function App({ Component, pageProps }: AppProps) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null; // ou um loading

  return (
    <AuthProvider>
      <Component {...pageProps} />
    </AuthProvider>
  )
}
